/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import React from 'react'
import PasswordRequirements from '../../../components/forms/password-requirements'
import useChangePasswordFields from '../../../components/forms/useChangePasswordFields'
import Field from '../../../components/field'

const ChangePasswordFields = ({form, prefix = ''}) => {
    const fields = useChangePasswordFields({form, prefix})

    const password = form.watch('newPassword')

    return (
        <Stack spacing="33px">
            <Stack spacing="13px">
                <Field {...fields.newPassword} />
                <PasswordRequirements value={password} />
            </Stack>
            <Stack spacing="13px">
                <Field {...fields.confirmPassword} />
                {/* <PasswordRequirements value={password} /> */}
            </Stack>
        </Stack>
    )
}

ChangePasswordFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default ChangePasswordFields
